import React from 'react';

// this is the equivalent to the createStore method of Redux
// https://redux.js.org/api/createstore

const AdminContext = React.createContext({ selectedTenant: null, setSelectedTenant: () => {} });

export default AdminContext;